import useAutoSiteRedirect from "../../hooks/useAutoSiteRedirect";

export default function AutoCountrySiteRedirect({ children }) {
  useAutoSiteRedirect();
  return children;
}
